<template>
<div class="chapter">
<div class="inner_page">
<p class="fnoindent1top"><a id="page_6">Dedicated to <span class="smallcaps">Hulbert Burroughs</span> in gratitude for his permission to write of Opar, that hidden city of “gold, and silver, ivory, and apes, and peacocks” and of the civilization which founded it.</a></p><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Dedication.vue?e8c39efa